// @ts-nocheck
import PropTypes from 'prop-types';
import { noCase } from 'change-case';
import { useRef, useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Icon } from '@iconify/react';
import bellFill from '@iconify/icons-eva/bell-fill';
import clockFill from '@iconify/icons-eva/clock-fill';
import doneAllFill from '@iconify/icons-eva/done-all-fill';
import {useNavigate} from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { useTheme } from '@mui/material/styles';

// material
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Chip,
  Stack,
  Tooltip,
  Divider,
  IconButton,
  Typography,
  TextField,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  useMediaQuery,
  ListItemButton
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import { useSnackbar } from 'notistack';
import { MIconButton, MAvatar } from '../../components/@material-extend';
import createAvatar from '../../utils/createAvatar';
import eyeFill from '@iconify/icons-eva/eye-fill';
import closeFill from '@iconify/icons-eva/close-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import JobsiteJoinModal from './JobsiteJoinModal';
import JobsiteSupervisorDocs from './jobsiteSupervisorDocs';
// utils
import mockData from '../../utils/mock-data';
import { fToNow } from '../../utils/formatTime';
// components
import Scrollbar from '../../components/Scrollbar';
import MenuPopover from '../../components/MenuPopover';
import { userAvatar, userAvatar100 } from '../../components/userImage';
import BlueCard from '../../components/_dashboard/user/profile/doc-templates/BlueCard';
import PublicLiabilityInsurance from '../../components/_dashboard/user/profile/doc-templates/PublicLiablityInsurance';
import QBCClicense from '../../components/_dashboard/user/profile/doc-templates/QBCCLicense';
import WorkCover from '../../components/_dashboard/user/profile/doc-templates/WorkCover';
import EWPLicense from '../../components/_dashboard/user/profile/doc-templates/EWPLicense';
import WorkingHeightsLicense from '../../components/_dashboard/user/profile/doc-templates/WorkingHeightsLicense';
import TestAndTag from '../../components/_dashboard/user/profile/doc-templates/TestAndTag';
import axios from '../../utils/axios';
import { notifications as subscribeNotifications } from '../../socket';
import useRoleName from 'src/hooks/useRoleName';
import { PATH_DASHBOARD } from 'src/routes/paths';
// ----------------------------------------------------------------------
const docTemplates = {
  cards: (props) => <BlueCard {...props} />,
  licenses: props=> <QBCClicense {...props} />,
  workCovers: props=> <WorkCover {...props} />,
  ewpCards: props=> <EWPLicense {...props} />,
  insurances: props=> <PublicLiabilityInsurance {...props} />,
  workingHeightsCards: props=> <WorkingHeightsLicense {...props} />,
  testTag: props=> <TestAndTag {...props} />,
}

const StyledBox = styled('div')(({ theme }) => {
  // console.log('them.pallete: ',theme.palette);
  return ({

    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '450px',
    background: theme.palette.background.paper,
    // border: '2px solid #000',
    boxShadow: '24px',
    padding: '15px',
    borderRadius: '10px'
  })
});
const joinModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  borderRadius:1,
  boxShadow: 24,
  p: 3,
};

const TITLES = [
  'Your order is placed',
  'Sylvan King',
  'You have new message',
  'You have new mail',
  'Delivery processing'
];

const DESCRIPTIONS = [
  'waiting for shipping',
  'answered to your comment on the Minimal',
  '5 unread messages',
  'sent from Guido Padberg',
  'Your order is being shipped'
];
const modalStyleDesktop = {
  position: 'absolute',
  width: 'calc(100% - 20px)',
  height: 'calc(100% - 20px)',
  bgcolor: '#161C24',
  borderRadius:'10px',
  boxShadow: 24,
  padding: '30px',
  top: '10px',
  left: '10px',

};
const modalStyleMobile = {
  position: 'absolute',
  width: 'calc(100% - 0px)',
  height: 'calc(100% - 0px)',
  bgcolor: '#161C24',
  borderRadius:'0px',
  boxShadow: 24,
  padding: '0px',
  top: '0px',
  left: '0px',

};

const TYPES = ['order_placed', 'friend_interactive', 'chat_message', 'mail', 'order_shipped'];

const AVATARS = [null, mockData.image.avatar(2), null, null, null];

const UNREADS = [true, true, false, false, false];

const MOCK_NOTIFICATIONS = [...Array(5)].map((_, index) => ({
  id: mockData.id(index),
  title: TITLES[index],
  description: DESCRIPTIONS[index],
  avatar: AVATARS[index],
  type: TYPES[index],
  createdAt: mockData.time(index),
  isUnRead: UNREADS[index]
}));

// ----------------------------------------------------------------------


export default function NotificationsPopover() {
  const roleName = useRoleName();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [jobsiteId, setJobsiteId] = useState(null);
  const [whsDoc, setWhsDoc] = useState(null);
  const [showAll, setShowall] = useState(false);
  const navigate = useNavigate();
  const [reason, setReason] = useState('');
  const [reasonBox, toggleReasonBox] = useState(false);
  let [loading, setLoading] = useState(false);
  let   [jobsiteOpen, toggleJobsiteModal] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const totalUnRead = notifications.filter((item) => item.seen == 0).length;
  const [currentDoc, setCurrentDoc] = useState(null);
  const [joinModal, toggleJoinModal] = useState(false);
  const [joinTeamModal, toggleJoinTeamModal] = useState(false);
  const [joinUser, setJoinUser] = useState(null);
  const [inviteModal, toggleInviteModal] = useState(false);
  const [inviteData, setInviteData] = useState(null);
  const [docModalOpen, toggleDocModal] = useState(false);
  const [supervisorDocsOpen, toggleSupervisorDocsModal] = useState(false);
  const closeDocModal = ()=> toggleDocModal(false);
  const openDocModal = ()=> toggleDocModal(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const toast = (type, message)=>{
    enqueueSnackbar(message, {
      variant: type,
      action: (key) => (
        <MIconButton size="small" onClick={() => closeSnackbar(key)}>
          <Icon icon={closeFill} />
        </MIconButton>
      )
    });
  }

  const fetchNotifications = async () => {
    try {
      const response = await axios.get('/v1/notifications');
      const body = response.data;
      const list = Array.isArray(body)
        ? body
        : (body?.data || body?.notifications || []);
      setNotifications(list);
    } catch (error) {
      console.error('Failed to load notifications:', error.message);
    }
  };

  useEffect(() => {
    fetchNotifications();
    subscribeNotifications((payload) => {
      // Backend emits the full notification object on single-create
      // and `{ type }` on bulk-create. Only surface a toast when we
      // have a human-readable title.
      const title = payload?.title;
      if (title) toast('info', title);
      fetchNotifications();
    });
  }, []);

  const fetchSafetyDoc = async (params) => {
    try {
      const r = await axios.get('/v1/documents/safety-doc', { params });
      const data = r.data?.data || r.data;
      setCurrentDoc(data);
      openDocModal();
    } catch (err) {
      toast('warning', err.message || 'Failed to load document');
    }
  }
  const handleOpen = () => {
    setOpen(true);
    fetchNotifications();
    setNotifications(notifications.map((item) => ({ ...item, seen: 1 })));
    axios.put('/v1/notifications/read-all').catch((error) => {
      console.error('Failed to mark notifications seen:', error.message);
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMarkAllAsRead = () => {
    setNotifications(notifications.map((n) => ({ ...n, status: 1 })));
    axios.put('/v1/notifications/read-all').catch((error) => {
      console.error('Failed to mark all read:', error.message);
    });
  };
  const updateNotificationStatus = notificationId=>{
    notifications.map(n=>{
      if(n.id==notificationId) n.status = 1;
    });
    setNotifications([...notifications])
  }

  const processVerifyDoc = res=>{
    setLoading(false);
    // console.log('verifyDoc: ',res);
    if(res.success){
      toast('success', 'Verified successfully');
      closeDocModal();
      setCurrentDoc(null);
      // var docData = res.data;
      // // console.log('teams: ',tems[0]);
      // tems.map(team=>{
      //   if(team.id==docData.teamId){
      //     team && team.employees.map((emp,index)=>{
      //       if(emp.id==docData.userId){
      //         // console.log('found emp: ',emp, docData);
      //         if(emp.docs[realCardNames[docData.docType]]) {
      //           // console.log('found: ',emp);
      //           emp.docs[realCardNames[docData.docType]].data = {...docData};
      //         }
      //       }
      //     })
      //   }

      // })
      // setTeams([...tems]);
      // tems = [...tems];

    }else{
      toast('warning', res.msg);
    }
  }


  const handleNotificationClick = async noti=>{
    // console.log('got notification: ',noti);
    if(noti.type=='jobsite'){
      // if(noti.status==0){ // show join job site modal
      //   // console.log('open job site modal');
      //   setSelectedNotification(noti);
      //   toggleJobsiteModal(true);
      // }else{
      //   toast('warning', "You already have joined this job site!")
      // }
    }else if(noti.type=='chat' || noti.type=='message'){
      let data = JSON.parse(noti.data);
      axios.put(`/v1/notifications/${noti.id}/read`).catch((error) => {
        console.error('Failed to mark notification read:', error.message);
      });
      updateNotificationStatus(noti.id);
      // console.log('message data: ',data);
      if(data.roomId) {
        navigate(`/dashboard/chat/${data.roomId}`);
        handleClose();
      }
    }else if(noti.type=='docUpdate'){
      let data = JSON.parse(noti.data);
      fetchSafetyDoc({ ...data, userId: noti.senderId });
    }else if(noti.type=='jobsiteSupervisorDoc'){
      let jId = JSON.parse(noti.data).jobsiteId;
      setJobsiteId(jId);
      toggleSupervisorDocsModal(true);
      setLoading(true);
      axios.get(`/v1/jobsites/${jId}/docs`)
        .then((response) => {
          const data = response.data?.data || response.data;
          if (data?.wesafeDoc) setWhsDoc(data.wesafeDoc);
          else if (data?.customDoc) setWhsDoc(data.customDoc);
          else setWhsDoc([]);
        })
        .catch((error) => toast('warning', error.message || 'Failed to load docs'))
        .finally(() => setLoading(false));
    }else if(noti.type=='team'){
      // A join request leaves no DB row — it stays valid until the requester
      // joins the team (the builder or another office admin may have accepted
      // it already). Check before opening the dialog so we don't offer to
      // accept someone who's no longer pending.
      let status;
      try {
        const { data } = await axios.get('/v1/team/join-request-status', {
          params: { userId: noti.senderId }
        });
        status = data;
        if (!data?.pending) {
          toast('warning', 'This request is no longer valid');
          fetchNotifications();
          return;
        }
      } catch (err) {
        toast('warning', err.message || 'Failed to check request');
        return;
      }
      setJoinUser({
        userId: noti.senderId,
        name: ((status?.senderFirstName ?? noti.senderFirstName) + ' ' + (status?.senderLastName ?? noti.senderLastName)).trim(),
        role: status?.senderRole ?? noti.senderRole,
        picture: status?.senderPicture ?? noti.senderPicture
      });
      toggleJoinModal(true);
    }else if(noti.type=='teamMember'){
      // Declared out here on purpose: the two fallbacks below read it, and
      // scoped to the try block it was simply not in scope by the time they
      // did — the click threw "data is not defined" and no invite could be
      // accepted from a notification at all.
      let inviteStatus = null;
      try {
        const { data } = await axios.get('/v1/team/invite-status', {
          params: { senderId: noti.senderId }
        });
        inviteStatus = data;
        if (!data?.pending) {
          toast('warning', 'This invitation is no longer valid');
          fetchNotifications();
          return;
        }
      } catch (err) {
        toast('warning', err.message || 'Failed to check invitation');
        return;
      }
      let parsed = {};
      try { parsed = typeof noti.data === 'string' ? JSON.parse(noti.data) : (noti.data || {}); }
      catch (e) { parsed = {}; }
      setJoinUser({
        senderId: noti.senderId,
        name: noti.senderFirstName+' '+noti.senderLastName,
        companyName: parsed.companyName || inviteStatus?.companyName || null,
        teamAvatarUrl: parsed.teamAvatarUrl || inviteStatus?.teamAvatar?.url || null,
        picture: noti.senderPicture,
        receiverId: noti.receiverId
      });
      toggleJoinTeamModal(true);
    }else if(noti.type=='jobsite_notice'){
      axios.put(`/v1/notifications/${noti.id}/read`).catch((error) => {
        console.error('Failed to mark notification read:', error.message);
      });
      updateNotificationStatus(noti.id);
      const jId = noti.jobsiteId || (noti.data && JSON.parse(noti.data).jobsiteId);
      if(jId) {
        navigate(`${PATH_DASHBOARD.user.jobdetails}/${jId}`);
        handleClose();
      }
    }else if(noti.type=='ptc_request' || noti.type=='docs_request'){
      axios.put(`/v1/notifications/${noti.id}/read`).catch((error) => {
        console.error('Failed to mark notification read:', error.message);
      });
      updateNotificationStatus(noti.id);
      try {
        const { data: status } = await axios.get('/v1/users/me/ptc-status');
        if (status.accepted) {
          toast('info', 'You have already accepted the Period Trade Contract');
          return;
        }
      } catch (err) { /* proceed to navigate */ }
      let parsed = {};
      try { parsed = typeof noti.data === 'string' ? JSON.parse(noti.data) : (noti.data || {}); }
      catch (e) { parsed = {}; }
      if (parsed.url) {
        navigate(parsed.url);
      } else if (parsed.builderUserId) {
        navigate(`/documents/accept?builderId=${parsed.builderUserId}`);
      }
      handleClose();
    }else if(noti.type=='invite'){
      let parsed = {};
      try { parsed = typeof noti.data === 'string' ? JSON.parse(noti.data) : (noti.data || {}); }
      catch (e) { parsed = {}; }
      if (!parsed.inviteId) {
        toast('warning', 'This invitation can no longer be opened');
        return;
      }
      // Pre-check: an invite notification can outlive the invite itself
      // (recipient already accepted/declined elsewhere, sender cancelled, or
      // it expired). Verify status === 'pending' before opening the modal so
      // we surface "no longer valid" instead of letting the accept/decline
      // PUT fail later.
      // Same reason as inviteStatus above: the two fallbacks below read this,
      // so it cannot live only inside the try.
      let invite = null;
      try {
        const { data } = await axios.get(`/v1/invites/${parsed.inviteId}`);
        invite = data;
        if (!invite || invite.status !== 'pending') {
          toast('warning', `This invitation is no longer valid${invite?.status ? ` (${invite.status})` : ''}`);
          fetchNotifications();
          return;
        }
      } catch (err) {
        if (err?.response?.status === 404) {
          toast('warning', 'This invitation was cancelled or removed');
        } else {
          toast('warning', err.message || 'Failed to load invitation');
        }
        fetchNotifications();
        return;
      }
      setInviteData({
        inviteId: parsed.inviteId,
        roleName: parsed.roleName || 'team member',
        senderName: `${noti.senderFirstName || ''} ${noti.senderLastName || ''}`.trim() || 'A WeSafe user',
        companyName: parsed.companyName || invite?.companyName || null,
        teamAvatarUrl: parsed.teamAvatarUrl || invite?.teamAvatar?.url || null,
        senderId: noti.senderId,
        notificationId: noti.id,
      });
      toggleInviteModal(true);
    }
  }

  const openProfile = userId=>{
    toggleJoinModal(false);
    navigate(PATH_DASHBOARD.user.profile+'/'+userId)
  }

  const acceptVerification = async (currentDoc)=>{
    setLoading(true);
    try {
      const response = await axios.put(
        `/v1/documents/compliance/${currentDoc.docType}/${currentDoc.id}/verify`,
        currentDoc
      );
      const data = response.data?.data || response.data;
      processVerifyDoc({ success: true, data });
    } catch (err) {
      processVerifyDoc({ success: false, msg: err.message || 'Failed to verify' });
    }
  }

  const handleDeclineCard = async ()=>{
    if(!currentDoc) return;
    if(reason.trim()===""){
      toast('warning', 'Please Enter a valid reason!');
      return;
    }
    setLoading(true);
    try {
      await axios.post(
        `/v1/documents/compliance/${currentDoc.docType}/${currentDoc.id}/decline`,
        { userId: currentDoc.userId, reason }
      );
      toggleReasonBox(false);
      setReason('');
      closeDocModal();
      setCurrentDoc(null);
      toast('success','Message sent to user');
    } catch (err) {
      toast('warning', err.message || 'Failed to decline');
    } finally {
      setLoading(false);
    }
  }

  const handleSupervisorDocAccept = async ()=>{
    setLoading(true);
    try {
      await axios.put(`/v1/jobsites/${jobsiteId}/supervisor-doc-accept`);
      toast('success', 'successfully accepted the document');
      toggleSupervisorDocsModal(false);
    } catch (err) {
      toast('warning', err.message || 'Failed to accept document');
    } finally {
      setLoading(false);
    }
  }

  const acceptJoinRequest = async (body) => {
    if(!joinUser){
      toast('warning', 'Something went wrong! please refresh the page');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/v1/team/accept-join', body);
      toggleJoinModal(false);
      toggleJoinTeamModal(false);
      setJoinUser(null);
      toast('success', 'Team joined successfully');
      handleClose();
    } catch (err) {
      toast('warning', err.message || 'Failed to join team');
    } finally {
      setLoading(false);
    }
  }

  const handleAcceptJoinRequest = () => acceptJoinRequest({ userId: joinUser?.userId });
  const handleAcceptTeamJoinRequest = () => acceptJoinRequest({
    employerRequest: true,
    senderId: joinUser?.senderId,
    receiverId: joinUser?.receiverId,
  });

  const handleAcceptInvite = async () => {
    if(!inviteData?.inviteId){
      toast('warning', 'Something went wrong! please refresh the page');
      return;
    }
    setLoading(true);
    try {
      await axios.put(`/v1/invites/${inviteData.inviteId}/accept`);
      toggleInviteModal(false);
      setInviteData(null);
      toast('success', 'Invitation accepted — welcome to the team');
      fetchNotifications();
      handleClose();
    } catch (err) {
      toast('warning', err.message || 'Failed to accept invitation');
    } finally {
      setLoading(false);
    }
  }

  const handleDeclineInvite = async () => {
    if(!inviteData?.inviteId){
      toast('warning', 'Something went wrong! please refresh the page');
      return;
    }
    setLoading(true);
    try {
      await axios.put(`/v1/invites/${inviteData.inviteId}/decline`);
      toggleInviteModal(false);
      setInviteData(null);
      toast('success', 'Invitation declined');
      fetchNotifications();
      handleClose();
    } catch (err) {
      toast('warning', err.message || 'Failed to decline invitation');
    } finally {
      setLoading(false);
    }
  }

  const handleDeclineTeamJoinRequest = async () => {
    if(!joinUser?.senderId){
      toast('warning', 'Something went wrong! please refresh the page');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/v1/team/decline-join', { senderId: joinUser.senderId });
      toggleJoinTeamModal(false);
      setJoinUser(null);
      toast('success', 'Invitation declined');
      fetchNotifications();
      handleClose();
    } catch (err) {
      toast('warning', err.message || 'Failed to decline invitation');
    } finally {
      setLoading(false);
    }
  }


  let oldNotifications = notifications.filter(item=> item.status==1);
  let newNotifications = notifications.filter(item=> item.status==0);

  return (
    <>
      <MIconButton
        ref={anchorRef}
        size="large"
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
        sx={{
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <Badge badgeContent={totalUnRead} color="error">
          <Icon icon={bellFill} width={20} height={20} />
        </Badge>
      </MIconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 360 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">Notifications</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              You have {newNotifications.length} unread notifications
            </Typography>
          </Box>

          {newNotifications.length > 0 && (
            <Tooltip title=" Mark all as read">
              <MIconButton color="primary" onClick={handleMarkAllAsRead}>
                <Icon icon={doneAllFill} width={20} height={20} />
              </MIconButton>
            </Tooltip>
          )}
        </Box>

        <Divider />

        <Scrollbar sx={{ height: 'auto' }} >
          {
            newNotifications.length>0?(
              <List
                disablePadding
                subheader={
                  <ListSubheader  sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                    New
                  </ListSubheader>
                }
              >
                {/* {
                  <Scrollbar sx={{ height: { xs: 340, sm: 'auto' }}}> */}
                    {
                      newNotifications.map((notification) => (
                        <NotificationItem key={notification.id} handleClick={handleNotificationClick} notification={notification} />
                      ))
                    }

                  {/* </Scrollbar>
                } */}

              </List>
            ):null
          }


          {
            oldNotifications.length==0? null: (
              <List
                disablePadding
                subheader={
                  <ListSubheader  sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                    Old
                  </ListSubheader>
                }
              >
                {
                  !showAll? (
                    <Scrollbar sx={{ height: { xs: 340, sm: 'auto' } }}>
                      {
                        oldNotifications.slice(0,5).map((notification) => (
                          <NotificationItem key={notification.id} handleClick={handleNotificationClick} notification={notification} />
                        ))
                      }
                    </Scrollbar>
                  ):(
                    <Scrollbar sx={{ height: { xs: 340, sm: 'auto' } }}>
                      {
                        oldNotifications.map((notification) => (
                          <NotificationItem key={notification.id} handleClick={handleNotificationClick} notification={notification} />
                        ))
                      }

                    </Scrollbar>
                  )
                }
              </List>
            )
          }

        </Scrollbar>



        {/* {
          oldNotifications.length==0 || showAll?null:(
            <div>
              <Divider />
              <Box sx={{ p: 1 }}>
                <Button fullWidth disableRipple onClick={()=> setShowall(true)}>
                  View All
                </Button>
            </Box>
            </div>

          )
        } */}

      <Modal
          open={docModalOpen}
          onClose={e=>closeDocModal()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
          <StyledBox>
			  <Box sx={{ mb:2 }}>
			  <h4 style={{ margin: 0 }}>Review document details</h4>
			  <p style={{ margin: '4px 0 0 0', fontSize: '0.875rem', opacity: 0.7 }}>Please confirm the information below before accepting or declining this submission.</p>
			  </Box>
          {
              currentDoc && docTemplates[currentDoc.docType] && docTemplates[currentDoc.docType]({
                  // currentDocTemplate,
                  doc: currentDoc,
                  editable: false,
                  loading,
                  toast
              })
          }
          <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2}} >
            <Button variant="outlined" color="inherit" onClick={e=>closeDocModal()}>Cancel</Button>
			<LoadingButton variant="contained" color="error" loading={loading} onClick={e=>toggleReasonBox(true)}>Decline</LoadingButton>
            <LoadingButton variant="contained" color="success" loading={loading} onClick={e=>acceptVerification(currentDoc)}>Accept</LoadingButton>
          </Box>

          </StyledBox>
        </Modal>
        <Modal
          open={reasonBox}
          onClose={e=>toggleReasonBox(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
          <StyledBox>
		   <Box sx={{ mb:2 }}>
		  		<h4>Please define the reason for declining this card</h4>
		  </Box>
          <TextField
				fullWidth
				multiline
				value={reason}
				onChange={e=>setReason(e.target.value)}
				minRows={5}
				maxRows={10}
				label="Reason"
			  />

		  <LoadingButton variant="outlined" color="warning" fullWidth loading={loading} sx={{mt:1}} onClick={handleDeclineCard}> Decline </LoadingButton>

          </StyledBox>
        </Modal>


      </MenuPopover>



      <JobsiteJoinModal open={jobsiteOpen} toggleModal={toggleJobsiteModal} notification={selectedNotification} />

          <Modal
          open={supervisorDocsOpen}
          onClose={e=>toggleSupervisorDocsModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
          <Box sx={isMobile? modalStyleMobile: modalStyleDesktop}>
            {/* {
              whsDoc?( */}
                <JobsiteSupervisorDocs loading={loading} toast={toast} handleDocAccept={handleSupervisorDocAccept} open={supervisorDocsOpen} toggleModal={toggleSupervisorDocsModal} doc={whsDoc} />
              {/* ):null
            } */}

          </Box>
        </Modal>

      <Modal
        open={joinModal}
        onClose={() => !loading && toggleJoinModal(false)}
        aria-labelledby="join-modal-title"
        aria-describedby="join-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 520,
            maxWidth: 'calc(100vw - 32px)',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 0,
            overflow: 'hidden',
          }}
        >
          {/* Accent header */}
          <Box
            sx={{
              height: 6,
              background: (t) =>
                `linear-gradient(90deg, ${t.palette.primary.main} 0%, ${alpha(
                  t.palette.primary.main,
                  0.55,
                )} 100%)`,
            }}
          />

          <Box sx={{ p: 3 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 2.5 }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'primary.main' }} />
                <Typography
                  variant="overline"
                  sx={{ letterSpacing: 1.5, color: 'text.secondary', fontWeight: 700, lineHeight: 1 }}
                  id="join-modal-title"
                >
                  Team request
                </Typography>
              </Stack>
              <IconButton
                size="small"
                disabled={loading}
                onClick={() => toggleJoinModal(false)}
                aria-label="Close"
              >
                <Icon icon={closeFill} width={18} height={18} />
              </IconButton>
            </Stack>

            <Box
              sx={{
                p: 2.5,
                borderRadius: 2,
                border: 1,
                borderColor: (t) => alpha(t.palette.primary.main, 0.14),
                bgcolor: (t) => alpha(t.palette.primary.main, 0.04),
                mb: 2.5,
              }}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <MAvatar
                  src={userAvatar100(joinUser?.picture) || undefined}
                  alt={joinUser?.name}
                  color={userAvatar100(joinUser?.picture) ? 'default' : createAvatar(joinUser?.name || '').color}
                  sx={{ width: 56, height: 56, fontSize: 22 }}
                >
                  {createAvatar(joinUser?.name || '').name}
                </MAvatar>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography
                    variant="subtitle1"
                    noWrap
                    onClick={() => joinUser?.userId && openProfile(joinUser.userId)}
                    sx={{ fontWeight: 700, cursor: joinUser?.userId ? 'pointer' : 'default', '&:hover': { textDecoration: joinUser?.userId ? 'underline' : 'none' } }}
                  >
                    {joinUser?.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.25 }}
                    id="join-modal-description"
                  >
                    Wants to join your team{joinUser?.role ? ` as a ${roleName(joinUser.role) || joinUser.role}` : ''}
                  </Typography>
                </Box>
              </Stack>
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                  fontSize: 11,
                  fontWeight: 700,
                  display: 'block',
                  mb: 1.25,
                }}
              >
                If you accept
              </Typography>
              <Box
                component="ul"
                sx={{
                  m: 0,
                  pl: 2.5,
                  listStyle: 'disc',
                  '& li': { pl: 0.5, pb: 0.5 },
                  '& li::marker': { color: 'primary.main', fontSize: '0.8em' },
                }}
              >
                <Typography component="li" variant="body2">
                  {joinUser?.name || 'They'} will join your team.
                </Typography>
                <Typography component="li" variant="body2">
                  You can assign them to jobsites and request safety documents.
                </Typography>
                <Typography component="li" variant="body2">
                  You can remove them from the team any time.
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={1.5}>
              <LoadingButton
                fullWidth
                variant="outlined"
                color="inherit"
                onClick={() => toggleJoinModal(false)}
                disabled={loading}
                sx={{ py: 1.25, borderColor: 'divider' }}
              >
                Reject
              </LoadingButton>
              <LoadingButton
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleAcceptJoinRequest}
                loading={loading}
                sx={{
                  py: 1.25,
                  boxShadow: (t) => `0 6px 16px ${alpha(t.palette.primary.main, 0.32)}`,
                  '&:hover': {
                    boxShadow: (t) => `0 8px 20px ${alpha(t.palette.primary.main, 0.4)}`,
                  },
                }}
              >
                Accept
              </LoadingButton>
            </Stack>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={joinTeamModal}
        onClose={e=>toggleJoinTeamModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={joinModalStyle}>
          {/* <Typography id="modal-modal-title" variant="h5" sx={{my:3}} component="h2">
            Request to join your team
          </Typography> */}

          <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <MAvatar
              variant="rounded"
              src={joinUser?.teamAvatarUrl || undefined}
              alt={joinUser?.companyName || joinUser?.name}
              color={joinUser?.teamAvatarUrl ? 'default' : createAvatar(joinUser?.companyName || joinUser?.name || '').color}
              sx={{ width: 72, height: 72, fontSize: 28 }}
            >
              {createAvatar(joinUser?.companyName || joinUser?.name || '').name}
            </MAvatar>
            <Typography variant="h6" sx={{mt: 1.5}}>
              {joinUser?.companyName || `${joinUser?.name}'s team`}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
              Invited by {joinUser?.name}
            </Typography>
          </Box>
          
            
            
          <Box  sx={{display: 'flex', justifyContent: 'space-around', mt:2}} >
            <LoadingButton variant="outlined" color="error" onClick={handleDeclineTeamJoinRequest} loading={loading}>Reject</LoadingButton>
            <LoadingButton variant="contained" onClick={handleAcceptTeamJoinRequest} type="button" color="primary" loading={loading}>
              Accept
            </LoadingButton>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={inviteModal}
        onClose={() => !loading && (toggleInviteModal(false), setInviteData(null))}
        aria-labelledby="invite-modal-title"
        aria-describedby="invite-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 520,
            maxWidth: 'calc(100vw - 32px)',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 0,
            overflow: 'hidden',
          }}
        >
          {/* Accent header */}
          <Box
            sx={{
              height: 6,
              background: (t) =>
                `linear-gradient(90deg, ${t.palette.primary.main} 0%, ${alpha(
                  t.palette.primary.main,
                  0.55,
                )} 100%)`,
            }}
          />

          <Box sx={{ p: 3 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 2.5 }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                  }}
                />
                <Typography
                  variant="overline"
                  sx={{
                    letterSpacing: 1.5,
                    color: 'text.secondary',
                    fontWeight: 700,
                    lineHeight: 1,
                  }}
                  id="invite-modal-title"
                >
                  Team invitation
                </Typography>
              </Stack>
              <IconButton
                size="small"
                disabled={loading}
                onClick={() => {
                  toggleInviteModal(false);
                  setInviteData(null);
                }}
                aria-label="Close"
              >
                <Icon icon={closeFill} width={18} height={18} />
              </IconButton>
            </Stack>

            <Box
              sx={{
                p: 2.5,
                borderRadius: 2,
                border: 1,
                borderColor: (t) => alpha(t.palette.primary.main, 0.14),
                bgcolor: (t) => alpha(t.palette.primary.main, 0.04),
                mb: 2.5,
              }}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <MAvatar
                  variant="rounded"
                  alt={inviteData?.companyName || inviteData?.senderName}
                  src={inviteData?.teamAvatarUrl || undefined}
                  color={inviteData?.teamAvatarUrl ? 'default' : createAvatar(inviteData?.companyName || inviteData?.senderName || '').color}
                  sx={{
                    width: 56,
                    height: 56,
                    fontSize: 22,
                  }}
                >
                  {createAvatar(inviteData?.companyName || inviteData?.senderName || '').name}
                </MAvatar>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography variant="subtitle1" noWrap sx={{ fontWeight: 700 }}>
                    {inviteData?.companyName || `${inviteData?.senderName}'s team`}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.25 }}
                    id="invite-modal-description"
                  >
                    Invited by {inviteData?.senderName}
                  </Typography>
                </Box>
              </Stack>
            </Box>

            <Box sx={{ mb: 2.5 }}>
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                  fontSize: 11,
                  fontWeight: 700,
                  display: 'block',
                  mb: 1,
                }}
              >
                Role
              </Typography>
              <Chip
                label={inviteData?.roleName || 'Team member'}
                sx={{
                  fontWeight: 600,
                  textTransform: 'capitalize',
                  bgcolor: (t) => alpha(t.palette.success.main, 0.14),
                  color: (t) =>
                    t.palette.mode === 'dark'
                      ? t.palette.success.light
                      : t.palette.success.dark,
                  borderRadius: 1,
                  height: 28,
                }}
              />
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                  fontSize: 11,
                  fontWeight: 700,
                  display: 'block',
                  mb: 1.25,
                }}
              >
                If you accept
              </Typography>
              <Box
                component="ul"
                sx={{
                  m: 0,
                  pl: 2.5,
                  listStyle: 'disc',
                  '& li': { pl: 0.5, pb: 0.5 },
                  '& li::marker': { color: 'primary.main', fontSize: '0.8em' },
                }}
              >
                <Typography component="li" variant="body2">
                  You'll join {inviteData?.companyName || `${inviteData?.senderName}'s team`} as a{' '}
                  {inviteData?.roleName}.
                </Typography>
                <Typography component="li" variant="body2">
                  They'll be able to assign you to jobsites and request safety
                  documents.
                </Typography>
                <Typography component="li" variant="body2">
                  You can leave the team any time from your profile.
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={1.5}>
              <LoadingButton
                fullWidth
                variant="outlined"
                color="inherit"
                onClick={handleDeclineInvite}
                loading={loading}
                sx={{ py: 1.25, borderColor: 'divider' }}
              >
                Decline
              </LoadingButton>
              <LoadingButton
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleAcceptInvite}
                loading={loading}
                sx={{
                  py: 1.25,
                  boxShadow: (t) =>
                    `0 6px 16px ${alpha(t.palette.primary.main, 0.32)}`,
                  '&:hover': {
                    boxShadow: (t) =>
                      `0 8px 20px ${alpha(t.palette.primary.main, 0.4)}`,
                  },
                }}
              >
                Accept invitation
              </LoadingButton>
            </Stack>
          </Box>
        </Box>
      </Modal>


    </>
  );
}













function getSenderDisplayName(notification) {
  const { senderFirstName, senderLastName, senderTradingName } = notification;
  if (senderFirstName || senderLastName) {
    return `${senderFirstName || ''} ${senderLastName || ''}`.trim();
  }
  return senderTradingName || '?';
}

function renderContent(notification) {
  const { senderFirstName, senderLastName } = notification;
  let name = senderFirstName + ' ' + senderLastName;
  let Title = notification.title;
  if(notification.type=='chat' || notification.type=='message') Title = name+ ' ' +Title;
  const title = (
    <Typography variant="subtitle2">
      {Title}
    </Typography>
  );

  if (notification.type === 'order_placed') {
    return {
      picture: <img loading="lazy" alt={Title} src="/static/icons/ic_notification_package.svg" />,
      title
    };
  }
  if (notification.type === 'order_shipped') {
    return {
      picture: <img loading="lazy" alt={Title} src="/static/icons/ic_notification_shipping.svg" />,
      title
    };
  }
  if (notification.type === 'mail') {
    return {
      picture: <img loading="lazy" alt={Title} src="/static/icons/ic_notification_mail.svg" />,
      title
    };
  }
  if (notification.type === 'chat_message') {
    return {
      picture: <img loading="lazy" alt={Title} src="/static/icons/ic_notification_chat.svg" />,
      title
    };
  }

  const avatarUrl = userAvatar(notification.senderPicture);
  if (avatarUrl) {
    return {
      picture: <img loading="lazy" alt={Title} src={avatarUrl} />,
      title
    };
  }
  return {
    picture: null,
    senderName: getSenderDisplayName(notification),
    title
  };
}

NotificationItem.propTypes = {
  notification: PropTypes.object.isRequired
};


function NotificationItem({ notification, handleClick }) {
  const { picture, senderName, title, } = renderContent(notification);
  const avatar = senderName ? createAvatar(senderName) : null;

  return (
    <ListItemButton
      to="#"
      disableGutters
      onClick={()=>handleClick(notification)}
      sx={{
        py: 1.5,
        px: 2.5,
        mt: '1px',
        ...(notification.isUnRead && {
          bgcolor: 'action.selected'
        })
      }}
    >
      <ListItemAvatar>
        {picture ? (
          <Avatar sx={{ bgcolor: 'background.neutral' }}>{picture}</Avatar>
        ) : (
          <MAvatar color={avatar?.color || 'default'} sx={{ width: 40, height: 40, fontSize: 14 }}>
            {avatar?.name || '?'}
          </MAvatar>
        )}
      </ListItemAvatar>
      <ListItemText
        primary={title}
        secondary={
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              display: 'flex',
              alignItems: 'center',
              color: 'text.disabled'
            }}
          >
            <Box component={Icon} icon={clockFill} sx={{ mr: 0.5, width: 16, height: 16 }} />
            {fToNow(new Date(notification.created))}
          </Typography>
        }
      />
    </ListItemButton>
  );
}